const API = {
  REACT_APP_BASE_URL: "https://myassettracker-api.azurewebsites.net",
  REACT_APP_CACHE_ENABLED: true,
};

module.exports = {
  API,
};
